export enum GenerationStatusEnum {
    PROCESSING = 'in_progress',
    GENERATED = 'completed',
    FAILED = 'failed'
}
